import Base from 'common/constants';
import React, { Component, useContext } from 'react';
import { Button } from '@mui/material';
import { GetOAuthToken, GetStateStorage, ResetAllLocalStorages, ResetDataExceptSessionSwitchLocalStorages, GetStateExpireTimerData, SetOAuthToken, SetStateInStorage, SetExpireTimerInStorage, IsValidSemiAuth, IsValidLoginAuth, GetOAuthTokenByKey } from 'common/storage';
import { ResetAllCookies } from 'common/cookies';
import moment from 'moment';
import axios, { aiServerConfig } from "common/interceptors";
import { isUserAdmin, isUserAgent } from 'common/roles/role';
import { LOG_MODULES, getLogListgenUserID, trackException, logLogout } from 'common/errorTracker';

const GetAuthorization = async () => {
    return btoa(`${Base.APP_DATA.APP_CLIENT_ID}:${Base.APP_DATA.APP_CLIENT_SECRET}`);
};

const style = {
    color: '#FFFFFF',
};

const autoHideDuration = 5000;

const verticalAnchorOrigin = 'top';

const horizontalAnchorOrigin = 'right';

/**
 * @name showNotification
 * @description shows notification as per given variant. Variant could be default | error | success | info | warning
 * @param {*} props 
 * @param {*} message 
 * @param {*} variant 
 */
const showNotification = async (props, message, variant, autoHideDuration, vertical = verticalAnchorOrigin, horizontal = horizontalAnchorOrigin) => {
    const action = (key) => (
        <Button onClick={() => { props.closeSnackbar(key) }} style={style}>
            {'Got It'}
        </Button>
    );
    // Wrap message in a styled element for 14px font size
    const styledMessage = <span style={{ fontSize: '15px' }}>{message}</span>;
    props.enqueueSnackbar(styledMessage, {
        variant,
        preventDuplicate: true,
        autoHideDuration,
        anchorOrigin: {
            vertical,
            horizontal,
        },
        action,
    });
};

/**
 * @name showDefaultNotification
 * @description shows default notification
 * @param {*} props 
 * @param {*} message
 * @param {*} hideDuration Default to autoHideDuration (5000)
 */
const showDefaultNotification = async (props, message, hideDuration = autoHideDuration, vertical = verticalAnchorOrigin, horizontal = horizontalAnchorOrigin) => {
    showNotification(props, message, 'error', hideDuration, vertical, horizontal);
};

/**
 * @name showSuccessNotification
 * @description shows success notification
 * @param {*} props 
 * @param {*} message
 * @param {*} hideDuration Default to autoHideDuration (5000)
 */
const showSuccessNotification = async (props, message, hideDuration = autoHideDuration, vertical = verticalAnchorOrigin, horizontal = horizontalAnchorOrigin) => {
    showNotification(props, message, 'success', hideDuration, vertical, horizontal);
};

/**
 * @name showInfoNotification
 * @description shows inof notification
 * @param {*} props 
 * @param {*} message
 * @param {*} hideDuration Default to autoHideDuration (5000)
 */
const showInfoNotification = async (props, message, hideDuration = autoHideDuration, vertical = verticalAnchorOrigin, horizontal = horizontalAnchorOrigin) => {
    showNotification(props, message, 'info', hideDuration, vertical, horizontal);
};

/**
 * @name showWarningNotification
 * @description shows warning notification
 * @param {*} props 
 * @param {*} message
 * @param {*} hideDuration Default to autoHideDuration (5000)
 */
const showWarningNotification = async (props, message, hideDuration = autoHideDuration, vertical = verticalAnchorOrigin, horizontal = horizontalAnchorOrigin) => {
    showNotification(props, message, 'warning', hideDuration, vertical, horizontal);
};

/**
 * @name showErrorNotification
 * @description shows error notification
 * @param {*} props 
 * @param {*} message
 * @param {*} hideDuration Default to autoHideDuration (5000)
 */
const showErrorNotification = async (props, message, hideDuration = autoHideDuration, vertical = verticalAnchorOrigin, horizontal = horizontalAnchorOrigin) => {
    showNotification(props, message, 'error', hideDuration, vertical, horizontal);
};
/**
 * @name commonSessionSwitchFn
 * @param {*} selectedAgentData Session switch for which agent
 * @param {*} reloadPage Whether to reload page or nor, default Yes
 * @param {*} refreshTimeInMS Refresh time in milli seconds, default 1000 milli seconds
 */
const commonSessionSwitchFn = (selectedAgentData, reloadPage = true, refreshTimeInMS = 1000) => {
    try {
        let currentTokenData = JSON.parse(GetOAuthToken());
        let currentStateData = GetStateStorage() || {};
        //we need this time because on every session switch we cannot increase the expire time. We arent generating oauth token on every session switch.
        let currentStateExpireTime = GetStateExpireTimerData();
        let { roleID, userName } = currentTokenData;
        if(selectedAgentData.listgenUserRoleID){
            selectedAgentData.listgenRoleID = selectedAgentData.listgenUserRoleID;
        }
        /**set the token again */
        /**set the agent profile also */
        //change username and role id + add old admin session data
        //If chaning keys here, then we need to update the AUTH_TOKEN_CONTEXT_KEYS_TO_PRESERVE in constants.jsx
        currentTokenData['roleID'] = selectedAgentData.listgenRoleID;
        currentTokenData['userName'] = selectedAgentData.emailAddress;
        /**assign only if have no old session data */
        if (currentTokenData && !currentTokenData.oldSessionData) {
            currentTokenData['oldSessionData'] = {
                userName,
                userID: currentStateData.userID,
                userData: currentStateData.userData,
                userRole: roleID
            };
        }
        // preserveState: true — only replaces OAuth keys, leaves LG_APP_STATE_DATA intact.
        // Without this, ResetAllLocalStorages() creates a gap where state is absent.
        // On Windows (LevelDB flush lag), the gap survives reload → mode=3 bounce.
        SetOAuthToken(currentTokenData, { preserveState: true });
        /**now update the current state data also */
        currentStateData['userID'] = selectedAgentData.listgenUserID;
        currentStateData['userData'] = selectedAgentData;
        currentStateData['userName'] = selectedAgentData.emailAddress;
        currentStateData['userRole'] = selectedAgentData.listgenRoleID;
        currentStateData['tokenData'] = currentTokenData;
        currentStateData['isUserLoggedIn'] = true;
        SetStateInStorage(currentStateData);
        /**Now set expire time also */
        SetExpireTimerInStorage(currentStateData, currentStateExpireTime);
        //Reset all cookies
        ResetAllCookies();
        //reload the screen to update all stores, if required
        if (reloadPage) {
            setTimeout(() => {
                window.location.reload();
            }, refreshTimeInMS);
        }
    } catch (err) {
        let stateUserID;
        let stateUserDataId;
        try {
            const state = GetStateStorage() || {};
            stateUserID = state.userID;
            stateUserDataId = state.userData?.listgenUserID;
        } catch {
            // ignore storage read errors during logging
        }
        trackException({
            module: LOG_MODULES.SESSION_SWITCH,
            code: 'SWITCH_FAILED',
            error: err,
            listgenUserID: getLogListgenUserID(
                stateUserID,
                stateUserDataId,
                selectedAgentData?.listgenUserID
            ),
            data: {
                switchedToListgenUserID: selectedAgentData?.listgenUserID,
                reloadPage,
            },
        });
        throw err;
    }
};


/**
 * @name convertV2AgentsDatatoV1
 * @param {*} v2AgentsData 
 */
const convertV2AgentsDatatoV1 = (v2AgentsData) => {
    v2AgentsData  =  v2AgentsData.map(agentData => {
        agentData.listgenRoleID = agentData.listgenRoleID ?? agentData.listgenUserRoleID;
        agentData.navbarInfo = agentData.navbarInfo ?? agentData.listAreaDetails;
        const scheduleId = agentData.pmaScheduleID ?? agentData.pmascheduleID;
        agentData.pmaScheduleID = agentData.pmascheduleID = scheduleId;
        
        //areaID to mlsAreaID
        //cityID to mlsCityID
        //cityName to mlsCityName
        //areaName to mlsNeighborhood

        if(agentData.navbarInfo){
            agentData.navbarInfo = agentData.navbarInfo.map(area => {
                area.mlsAreaID = area.areaID;
                area.mlsCityID = area.cityID;
                area.mlsCityName = area.cityName;
                area.mlsNeighborhood = area.areaName;
                return area;
            });
        }
        return agentData;
    });
    return v2AgentsData;
}

// Root cause: a dying page often has several authenticated API calls in flight.
// The first 401 calls handleLogoutFn(6), but the others still resolve and each
// called handleLogoutFn(6) again before navigation finished — stacking redirects
// and duplicate "Session expired abruptly" reloads on /login.
let logoutRedirectInProgress = false;
let logoutCookieClearFired = false;

/**
 * @name handleLogoutFn
 * @param {*} logoutMode By which mode logging out in system, default would be 1
 */
const handleLogoutFn = (logoutMode = 1, reloadPage = true) => {
    // Ignore duplicate forced-logout redirects from parallel late 401s.
    if (reloadPage && logoutRedirectInProgress) {
        return;
    }
    //log BEFORE storage reset so the listgen user ID can still be resolved
    logLogout(logoutMode, reloadPage);
    ResetAllLocalStorages();
    //Reset except session switch data also
    ResetDataExceptSessionSwitchLocalStorages();
    //Reset all cookies
    ResetAllCookies();
    // Ask CF Worker to clear httpOnly cookies (LG_ACCESS, LG_REFRESH, LG_SESS).
    // Only needed when actually redirecting to login — not for silent local resets
    // (e.g. handleLogoutFn(0, false) used by token validators before setting new auth).
    // Guard prevents duplicate calls when logout triggers from multiple places simultaneously.
    if (reloadPage && !logoutCookieClearFired) {
        logoutCookieClearFired = true;
        try {
            fetch(`${Base.APP_URLS.API_BASE}/oauth/logout`, {
                method: 'POST',
                credentials: 'include',
            }).catch(() => {});
        } catch {}
    }
    //redirect page
    if (reloadPage) {
        logoutRedirectInProgress = true;
        window.location.href = `/login?mode=${logoutMode}`;
    }
};

/**
 * @name isAFaultyPage
 * @param {*} userRoleID Current session user role id, from storage
 * @param {*} storageUserID storage session listgen user id
 * @param {*} queryParmaUserID query params session user listgen id
 */
const isAFaultyPage = async (userRoleID, storageUserID, queryParmaUserID) => {
    return new Promise((resolve, reject) => {
        if (isUserAgent(userRoleID) && storageUserID !== queryParmaUserID) {
            //both have different session ids so change. faulty page redirect to dashbaord
            window.location.href = '/dashboard?mode=2';
            //reject('/dashboard?mode=2');
        }
        resolve(false);
    });
};


/**
 * @name isCommonEmptyCheck
 * @param {*} value 
 * @returns true if the value is empty. false means value is not empty, null, undefined etc
 */
const isCommonEmptyCheck = (value) => {
    return (typeof value === "undefined" || value === null || !value || value.toString().length === 0);
}

/**
 * @name getDefaultStateID
 * @description To get listgen default state ID
 * @param {*} listgenUserRole 
 * @param {*} listgenUserID 
 * @returns 
 */
const getDefaultStateID = (listgenUserRole, listgenUserID) => {
    return isUserAdmin(listgenUserRole) ? Base.APP_DATA.APP_STATE_ID : '';
};

/**
 * @name getDefaultCountyID
 * @description To get listgen default county ID
 * @param {*} listgenUserRole 
 * @param {*} listgenUserID 
 * @returns 
 */
const getDefaultCountyID = (listgenUserRole, listgenUserID) => {
    return isUserAdmin(listgenUserRole) ? Base.APP_DATA.APP_COUNTY_ID : '';
};

/**
 * @name systemLogRequest
 * @description To log system request on Sentry.
 * @param {*} listgenUserID 
 * @param {*} code 
 * @param {*} error 
 * @param {*} data 
 */
const systemLogRequest = (page, code, error, data = {}) => {
    trackException({
        module: page,
        code: String(code),
        error,
        data,
    });
};

/**
 * @name getPrintTimesText
 * @description Calculate current agent PMA print count
 * @param {*} param0 
 * @returns return
 */

const getAgentPrintTimesText = ({ totalTimesMailed, totalTimesPMAPrinted, totalTimesPrinted }) => {
    let versionTimesPrinted = null;
    let keyToCheckDueToVersioning =
        totalTimesPrinted ?? totalTimesPMAPrinted ?? totalTimesMailed;
    versionTimesPrinted =
        parseInt(keyToCheckDueToVersioning) > 0 ? parseInt(keyToCheckDueToVersioning) + 1 : 1; //Add 1 if count is greater than 0 because total count is how many times agent printed the PMA. so current one will be +1 to total count.
    let versionTimesPrintedText = "";
    //add suffix to print number
    if (versionTimesPrinted == 1) {
        versionTimesPrintedText = "1st";
    } else if (versionTimesPrinted == 2) {
        versionTimesPrintedText = "2nd";
    } else if (versionTimesPrinted == 3) {
        versionTimesPrintedText = "3rd";
    } else {
        versionTimesPrintedText = `${versionTimesPrinted}th`;
    }
    return versionTimesPrintedText;
};

/**
 * @name formatUsNumber02
 * @description US English number: comma thousands, 0–2 decimal places (e.g. 551 → "551", 1234.567 → "1,234.57")
 * @param {*} value
 * @returns {string|null} formatted string, or null if invalid
 */
const formatUsNumber02 = (value) => {
    const num = typeof value === "string" ? Number(value) : value;
    if (value === null || value === undefined || value === "" || Number.isNaN(num)) {
        return null;
    }
    return num.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
};

/**
 * @name SortArrayByMonth
 * @description Sort an array by months
 * @param {*} arr 
 * @param {*} monthKey Key by which month can be accessed
 */
const SortArrayByMonth = (arr, monthKey, abbrevationMode = true) => {
    const months = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
    const monthsAbbrevated = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec", ""];
    const finalMonths = abbrevationMode ? monthsAbbrevated : months;
    arr.sort(function (a, b) {
        return finalMonths.indexOf(a[monthKey] || "") - finalMonths.indexOf(b[monthKey] || "");
    });
    return arr;
}

/**
 * @name capitalizeFirstLetter
 * @param {*} inputString 
 * @returns 
 */
const capitalizeFirstLetterForFirstWord = (inputString) => {
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
}

/**
 * capitalizeFirstLetterForEveryWord
 * @param {*} inputString 
 * @returns 
 */
const capitalizeFirstLetterForEveryword = (inputString) => {
    return inputString ? inputString.split(" ").reduce((previousValue, currentValue) => previousValue + " " + capitalizeFirstLetterForFirstWord(currentValue), "") : ""
}

/**
 * @name getCityFromCityString
 * @param {*} city 
 * @param {*} mode city | cityID
 * @returns 
 */
export const getCityFromCityString = (city, mode = 'city') => {
    if (city) {
        let splitCity = city.split(':')
        return (mode === 'city' ? splitCity[0] : splitCity[1])
    } else {
        return city;
    }
}


const getSystemDateFormat = (inputDate) => {
    return inputDate ? moment(new Date(inputDate)).format(
        "MMM DD, YY"
    ) : '';
}


const CommonAxiosAPIHandler = (mode = "get", fnParams, options = null, useAiServer = false) => {
    const headers = {
        "Content-Type": "application/json",
        // Authorization injected by CF Worker from httpOnly LG_ACCESS cookie
    };
    const requestHeaders = options || headers;
    
    // Choose axios instance based on useAiServer parameter
    const axiosInstance = useAiServer ? aiServerConfig : axios;
    
    let axiosFn = null;
    if (mode === 'GET') {
        axiosFn = axiosInstance.get(fnParams[0], { headers: requestHeaders, data: {} })
    } else {
        axiosFn = axiosInstance({
            method: mode,
            url: fnParams[0],
            data: fnParams[1],
            headers: requestHeaders
        })
    }
    return new Promise(async (resolve, reject) => {
        try {
            axiosFn
                .then((res) => {
                    if (res.status === 200) {
                        resolve(res.data);
                    } else {
                        reject("Unable to process request.");
                    }
                })
                .catch((err) => {
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.error_description
                    )
                        reject(err.response.data.error_description);
                    else reject("OOPS!!! something went wrong.");
                });
        } catch (err) {
            reject("Something went wrong. Unable to process request.");
        }
    });
};

const isAKylesAccount = (agentData) => {
    const { listgenUserID } = agentData || {};
    return (listgenUserID === "100076" || listgenUserID === "100047" || listgenUserID === '103406');
}

const copyToClipboard = (message) => {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(message).then(() => {
            alert("Data copied to clipboard!");
        }).catch(err => {
            console.error("Failed to copy text: ", err);
        });
    } else {
        const textarea = document.createElement("textarea");
        textarea.value = message;
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand("copy");
            alert("Data copied to clipboard!");
        } catch (err) {
            console.error("Fallback: Oops, unable to copy", err);
        }
        document.body.removeChild(textarea);
    }
}

const formatPhoneNumber = (phoneNumberString) => {
    if (!phoneNumberString) {
      return '';
    }
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    if (cleaned.length > 6) {
      const match = cleaned.match(/^(\d{3})(\d{3})(\d+)$/);
      if (match) {
        return match[1] + '-' + match[2] + '-' + match[3];
      }
    }  
    return null;
  };


export {
    GetAuthorization,
    showDefaultNotification,
    showSuccessNotification,
    showInfoNotification,
    showWarningNotification,
    showErrorNotification,
    commonSessionSwitchFn,
    handleLogoutFn,
    isAFaultyPage,
    isCommonEmptyCheck,
    getDefaultStateID,
    getDefaultCountyID,
    systemLogRequest,
    getAgentPrintTimesText,
    formatUsNumber02,
    SortArrayByMonth,
    capitalizeFirstLetterForFirstWord,
    capitalizeFirstLetterForEveryword,
    getSystemDateFormat,
    CommonAxiosAPIHandler,
    isAKylesAccount,
    convertV2AgentsDatatoV1,
    copyToClipboard,
    formatPhoneNumber
}